import { endpoint } from "../utils/endpoint";
import * as axiosService from "./axiosRequests";

const FUNNEL_ENDPOINT = endpoint("app/v1.0/funnel.json");

export async function getFunnel(params = {}, additionalOptions = {}) {
  const response = await axiosService.axiosGet(FUNNEL_ENDPOINT, params, {}, additionalOptions);
  return response.data;
}
